import { render, staticRenderFns } from "./CreateOrganisation.vue?vue&type=template&id=249c251a&scoped=true"
import script from "./CreateOrganisation.vue?vue&type=script&lang=js"
export * from "./CreateOrganisation.vue?vue&type=script&lang=js"
import style0 from "./CreateOrganisation.vue?vue&type=style&index=0&id=249c251a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249c251a",
  null
  
)

export default component.exports